/* VinZone free vehicle consultation (27 Oct 2026). Snippet: snippets/vz-consult.liquid */
(function () {
  if (window.__vzc) return; window.__vzc = true;
  var FALLBACK_EMAIL = 'callback-request@vinzone.io';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var sec = document.getElementById('free-check');
    var form = document.getElementById('vzc-form');

    /* Articles: move the inline card under "Can I drive it?" */
    var inline = document.querySelector('[data-vzc-inline]');
    var drive = document.querySelector('.vzfa #drive');
    if (inline && drive && drive.parentNode) drive.parentNode.insertBefore(inline, drive.nextSibling);

    /* Smooth scroll to the form and focus the first field */
    function go(e) {
      if (!sec) return;
      if (e) e.preventDefault();
      sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      var first = form && form.querySelector('input:not([type=hidden]), textarea');
      if (first) setTimeout(function () { try { first.focus({ preventScroll: true }); } catch (x) { first.focus(); } }, reduce ? 0 : 650);
      if (history.replaceState) history.replaceState(null, '', '#free-check');
    }
    [].forEach.call(document.querySelectorAll('[data-vzc-go]'), function (a) { a.addEventListener('click', go); });

    /* After a submit Shopify reloads the page: bring the thank-you into view */
    if (sec && (/contact_posted=true/.test(location.search) || location.hash === '#vzc-form' || location.hash === '#free-check' || (form && form.querySelector('.vzc-err')))) {
      setTimeout(function () { sec.scrollIntoView({ block: 'start' }); }, 300);
    }

    /* Sticky button: show after scrolling, hide while the form is on screen */
    var sticky = document.querySelector('[data-vzc-sticky]');
    if (sticky) {
      var formVisible = false;
      var update = function () { sticky.classList.toggle('is-on', window.scrollY > 520 && !formVisible); };
      if (sec && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { formVisible = en[0].isIntersecting; update(); }, { threshold: 0.15 }).observe(sec);
      }
      window.addEventListener('scroll', update, { passive: true });
      update();
    }

    /* Form */
    if (form) {
      var email = form.querySelector('[data-vzc-email]');
      if (email) email.removeAttribute('required');
      var page = form.querySelector('[data-vzc-page]');
      if (page) page.value = location.origin + location.pathname;
      var vin = form.querySelector('#vzc-vin');
      if (vin) vin.addEventListener('input', function () { var p = vin.selectionStart; vin.value = vin.value.toUpperCase().replace(/[^A-Z0-9]/g, ''); try { vin.setSelectionRange(p, p); } catch (x) {} });
      form.addEventListener('submit', function (e) {
        if (!form.checkValidity()) return;
        if (email && !email.value.trim()) email.value = FALLBACK_EMAIL;
        var b = form.querySelector('[data-vzc-submit]');
        if (b) { b.disabled = true; b.textContent = b.getAttribute('data-busy') || '…'; }
      });
    }
  });
})();
